module.exports = (__webpack_require__(67))(0);


//////////////////
// WEBPACK FOOTER
// delegated ./node_modules/react/cjs/react.production.min.js from dll-reference vendor
// module id = 213
// module chunks = 41